
<script>
import ChanelDonut from "@/components/chanelDonut";


export default {

  components: { ChanelDonut},

  props:{
    osFrequency: {
      type: Object,
      default: () => null,
    },

  },

  computed: {
  osFrequencyData() {
    return Object.values(this.osFrequency); 
  },
  osFrequencyLabels() {
    return Object.keys(this.osFrequency); 
  },
  },
};
</script>

<template>

    <div class="card" v-if="osFrequency"  style="border:1px solid #ddd;">
      <div class="card-body ">      

        <h4 class="text-dark text-uppercase font-weight-bold">{{$t('reporting.customer.deviceOs')}}</h4>

        <ChanelDonut :data="osFrequencyData" :labels="osFrequencyLabels" :hideLeagend="false" />
      </div>
    </div>

</template>
